/**
 * Gets the number of user recipes inside folder from the global Zustand store.
 * @return {number} The number of user recipes.
 */
export function getUserFolderRecipeAmount(id: string | undefined): number {
	const lists = window.valioApp.store.data.lists;

	if (!id || !lists || !lists[id]) {
		return 0;
	}

	return lists[id].itemCount || 0;
}
